import React from 'react';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';

const WidgetWrapper = (props) => {
  const {
    title,
    children,
    onClickRefreshBtn,
    onClickExpand,
    isCustom = false,
    // isInformation,
    className = '',
    subTitle = '',
    showReloadButton = false,
    selectedCategory,
  } = props;

  const titleFontSize =
    title === 'Total Orders' ||
    title === 'Request Count' ||
    title === `Requested Services ${selectedCategory}` ||
    title === `Top Selling Items ${selectedCategory}` ||
    title === `Top Upsell Items ${selectedCategory}` ||
    title === 'Total Reservations' ||
    title === 'Total Appointments'
      ? 'analytic-subtitle'
      : 'analytic-title';

  return (
    <div className={`${className}`}>
      <div className='widget-card-wrapper'>
        <div className='analytic-header-wrapper row d-flex'>
          <div className='col-md-7 d-flex row'>
            <span className={`${titleFontSize}`}>{title}</span>
            <span className='analytic-subtitle descriptionText'>{subTitle}</span>
          </div>
          <div className='col-md-5 d-flex justify-content-end'>
            <>
              {!isCustom && (
                <img
                  title='Fullscreen'
                  className='me-2 analytic-refresh-icon'
                  src={'./assets/icons/dashboard/zoom_out.svg'}
                  alt={'completed'}
                  onClick={onClickExpand}
                />
              )}
            </>
            {showReloadButton && (
              <>
                <img
                  title='Reload'
                  className='mt-1 ms-1 me-4 analytic-refresh-icon'
                  src={'./assets/icons/dashboard/sync-icon.svg'}
                  alt={'completed'}
                  onClick={onClickRefreshBtn}
                />
              </>
            )}
            {/* {isInformation && (
              <div>
                <Tooltip title={isInformation} placement="right">
                  <InfoIcon
                    style={{ fontSize: "15px" }}
                    className="mt-2 mr-2"
                  />
                </Tooltip>
              </div>
            )} */}
          </div>
        </div>
        <div className='analytic-breaker' />

        {children}
      </div>
    </div>
  );
};

export default WidgetWrapper;
